// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Ea12T","logo":"Header_logo__PhOyE"};